import { TAG_TYPES } from '../../../../Shared/constants/commonConstants';

// Stable substring of the backend's waitlist edit-up rejection message
// (see BookingsConstants.EDIT_UP_NOT_ALLOWED). Used to map the error to a friendly message.
export const EDIT_UP_ERROR_MARKER = 'Edit-up not allowed';

export const DETAILED_BOOKING_IMP_FIELDS = {
  ENTRY_NUMBER: 'entryNumber',
  BRAND: 'brand',
  AE_NAME: 'aeName',
  CATEGORY: 'category',
  TYPE_OF_PURCHASE: 'typeOfPurchase',
  SLOT_FOR_GP: 'slotForGP',
  VALUE_BLOCKED_BY_LINE_ITEM: 'valueBlockedByLineItem',
  IMPRESSIONS_BLOCKED_OVER_CONTEXTUAL_NODE:
    'impressionsBlockedOverContextualNode',
  IM_SEGMENT: 'imSegment',
  VALUE_TO_BE_LOCKED_AT_PACKAGE_LEVEL: 'valueToBeLockedAtPackageLevel',
  IMPRESSIONS: 'impressions',
  APPROX_SHARE_BLOCKED_OVER_NODE: 'approxShareBlockedOverNode',
} as const;

export const DETAILED_BOOKING_SOV_FIELDS = {
  ENTRY_NUMBER: 'entryNumber',
  BRAND: 'brand',
  AE_NAME: 'aeName',
  CATEGORY: 'category',
  TYPE_OF_PURCHASE: 'typeOfPurchase',
  GP_SLOT: 'gpSlot',
  SOV_PERCENTAGE_FOR_GP: 'sovPercentageForGP',
  VALUE_BLOCKED_BY_LINE_ITEM: 'valueBlockedByLineItem',
  CONTEXTUAL_NODE: 'contextualNode',
  SOV_PERCENTAGE_FOR_CONTEXTUAL_GP: 'sovPercentageForContextualGP',
  IMPRESSION_BOOKED: 'impressionBooked',
  VALUE_BOOKED: 'valueBooked',
} as const;

//TODO API: getNodesList,  Gets the list for “Contextual Node or IM Segment“ fields available in the bookingCreation form.
export const IM_SEGMENT_OPTIONS = [
  { id: 'im-segment-1', value: 'segment-1', label: 'Segment 1' },
  { id: 'im-segment-2', value: 'segment-2', label: 'Segment 2' },
  { id: 'im-segment-3', value: 'segment-3', label: 'Segment 3' },
  { id: 'im-segment-4', value: 'segment-4', label: 'Segment 4' },
];

// TODO: The constants will be removed once API Integration would be done.
export const CONTEXTUAL_NODE_OPTIONS = [
  { id: 'contextual-node-1', value: 'node-1', label: 'Node 1' },
  { id: 'contextual-node-2', value: 'node-2', label: 'Node 2' },
  { id: 'contextual-node-3', value: 'node-3', label: 'Node 3' },
  { id: 'contextual-node-4', value: 'node-4', label: 'Node 4' },
];

export const IMP_SLOT_OPTIONS = [
  { id: 'star-package', value: 'star-package', label: 'Star Package' },
  {
    id: 'mcontextual-package',
    value: 'mcontextual-package',
    label: 'mContextual Package',
  },
  {
    id: 'dcontextual-package',
    value: 'dcontextual-package',
    label: 'dContextual Package',
  },
  { id: 'hqp-class-1', value: 'hqp-class-1', label: 'HQP Class 1' },
  { id: 'mthankyou', value: 'mthankyou', label: 'MThankYou' },
];

// TODO: The constants will be removed once API Integration would be done.
export const SOV_GP_SLOT_OPTIONS = [
  { id: 'contextual', value: 'contextual', label: 'Contextual' },
  { id: 'non-contextual', value: 'non-contextual', label: 'Non-Contextual' },
];

export enum DetailedFormType {
  IMP = 'IMP',
  SOV = 'SOV',
}

export enum BookingStep {
  INITIAL = 'initial',
  DETAILED = 'detailed',
}

export const TYPE_OF_PURCHASE = {
  GP_SOV: 'GP SOV',
  GP_IMP: 'GP IMP',
  GP_CLASS: 'GP Class 1',
  NGP: 'NGP',
  STANDARD: 'Standard',
} as const;

export const BOOKING_STATUS = {
  DELETED: 'DELETED',
  CANCELLED: 'CANCELLED',
  ACTIVE: 'ACTIVE'
}


export const GTM_STATUS = {
  GTM_READY: 'GTM_READY',
  GTM_NOT_READY: 'GTM_NOT_READY',
  SENT_FOR_GTM_REVIEW: 'SENT_FOR_GTM_REVIEW',
} as const;

export const GTM_STATUS_ENUM_TO_LABEL_MAP = [
  { label: 'gtm-status-ready', value: GTM_STATUS.GTM_READY, display: 'GTM Ready', color: 'green' },
  { label: 'gtm-status-sent-for-review', value: GTM_STATUS.SENT_FOR_GTM_REVIEW, display: 'Sent for GTM Review', color: 'blue' },
  { label: 'gtm-status-not-ready', value: GTM_STATUS.GTM_NOT_READY, display: 'GTM Not Ready', color: 'red' },
] as const;

export const getGtmStatusDisplay = (value?: string): string =>
  GTM_STATUS_ENUM_TO_LABEL_MAP.find((item) => item.value === value)?.display ?? (value ?? '');

export const SLOT_PACKAGE_DISPLAY_NAMES: Record<string, string> = {
  'Star Package': 'Star Package',
  'STAR PACKAGE': 'Star Package',
  'IM': 'Star Package',
  'mThankyou': 'mThankyou',
  'MTHANKYOU': 'mThankyou',
  'CPG-MTHANKYOU': 'mThankyou',
  'MOBILE DETAILS': 'Mobile Details',
  'MOBILE DETAILS ENCORE': 'Mobile Details Encore',
  'DESKTOP DETAILS': 'Desktop Details',
  'DESKTOP SEARCH LEFT': 'Desktop Search Left',
  'MCONTEXTUAL': 'mContextual',
  'DCONTEXTUAL': 'dContextual',
  'MCONTEXTUAL CLASS 1 CPM': 'mContextual Class 1 CPM',
  'DCONTEXTUAL CLASS 1 CPM': 'dContextual Class 1 CPM',
  'ILM CLASS 1': 'ILM Class 1',
  'PPP CLASS 1': 'PPP Class 1',
  'WP CLASS 1': 'WP Class 1',
  'WD2 TARGETED CLASS 1': 'WD2 Targeted Class 1',
  'ROS DSP UNGUARANTEED': 'ROS DSP Unguaranteed',
  'SEARCH BTF DSP': 'Search BTF DSP',
  'HQP CLASS 1': 'HQP Class 1',
  'HQP + ILM DSP': 'HQP + ILM DSP',
  'MobileHQPSOV': 'MobileHQPSOV',
  'MOBILEHQPSOV': 'MobileHQPSOV',
};

export const getSlotPackageDisplayName = (slotPackageName: string): string =>
  SLOT_PACKAGE_DISPLAY_NAMES[slotPackageName] ?? slotPackageName;

export const IMP_CONTEXTUAL_NODE_FIELDS = [
  {
    key: DETAILED_BOOKING_IMP_FIELDS.IM_SEGMENT,
    labelKey: 'im-segment-label',
    placeholderKey: 'select-im-segment-placeholder',
    type: TAG_TYPES.DROPDOWN_TAG_TYPE,
    options: IM_SEGMENT_OPTIONS,
  },
  {
    key: DETAILED_BOOKING_IMP_FIELDS.VALUE_TO_BE_LOCKED_AT_PACKAGE_LEVEL,
    labelKey: 'value-locked-package-level-label',
    placeholderKey: 'value-locked-package-level-placeholder',
    type: TAG_TYPES.INPUT_TAG_TYPE,
  },
  {
    key: DETAILED_BOOKING_IMP_FIELDS.IMPRESSIONS,
    labelKey: 'impressions-label',
    placeholderKey: 'impressions-placeholder',
    type: TAG_TYPES.INPUT_TAG_TYPE,
  },
  {
    key: DETAILED_BOOKING_IMP_FIELDS.APPROX_SHARE_BLOCKED_OVER_NODE,
    labelKey: 'approx-share-blocked-label',
    placeholderKey: 'approx-share-blocked-placeholder',
    type: TAG_TYPES.INPUT_TAG_TYPE,
  },
] as const;

export enum GP_SLOT_VALUES {
  CONTEXTUAL = 'contextual',
  NON_CONTEXTUAL = 'non-contextual',
};

export enum SOV_CONTEXTUAL_NODE_KEYS {
  CONTEXTUAL_NODE = 'contextualNode',
  SOV_PERCENTAGE_FOR_CONTEXTUAL_GP = 'sovPercentageForContextualGP',
  IMPRESSION_BOOKED = 'impressionBooked',
  VALUE_BOOKED = 'valueBooked',

}

export const SOV_CONTEXTUAL_NODE_FIELDS = [
  {
    key: SOV_CONTEXTUAL_NODE_KEYS.CONTEXTUAL_NODE,
    labelKey: 'sov-contextual-node-label',
    placeholderKey: 'sov-select-contextual-node-placeholder',
    type: TAG_TYPES.DROPDOWN_TAG_TYPE,
    options: CONTEXTUAL_NODE_OPTIONS,
  },
  {
    key: SOV_CONTEXTUAL_NODE_KEYS.SOV_PERCENTAGE_FOR_CONTEXTUAL_GP,
    labelKey: 'sov-percentage-contextual-gp-label',
    placeholderKey: 'sov-percentage-contextual-gp-placeholder',
    type: TAG_TYPES.INPUT_TAG_TYPE,
  },
  {
    key: SOV_CONTEXTUAL_NODE_KEYS.IMPRESSION_BOOKED,
    labelKey: 'impression-booked-label',
    placeholderKey: 'impression-booked-placeholder',
    type: TAG_TYPES.INPUT_TAG_TYPE,
  },
  {
    key: SOV_CONTEXTUAL_NODE_KEYS.VALUE_BOOKED,
    labelKey: 'value-booked-label',
    placeholderKey: 'value-booked-placeholder',
    type: TAG_TYPES.INPUT_TAG_TYPE,
  },
] as const;

export enum IMPFormErrorType {
  IMPRESSIONS = 'impressions',
  BUDGET = 'budget',
}